import { configureStore } from "@reduxjs/toolkit";
import appReducer from "../redux/features/app/appSlice";
import userReducer from "../redux/features/app/userSlice";

export default configureStore({
  reducer: {
    app: appReducer,
    user: userReducer,
  },
});
